var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0515 33.3698L1.38488 18.3698C1.16415 18.2158 0.983878 18.0107 0.859401 17.772C0.734924 17.5333 0.669922 17.2681 0.669922 16.999C0.669922 16.7298 0.734924 16.4646 0.859401 16.2259C0.983878 15.9873 1.16415 15.7822 1.38488 15.6281L23.0515 0.628136C23.3017 0.455043 23.5945 0.353718 23.8981 0.335142C24.2017 0.316566 24.5047 0.381447 24.7741 0.522755C25.0435 0.664062 25.269 0.876405 25.4264 1.13677C25.5837 1.39714 25.6667 1.6956 25.6665 1.9998V9.33922C33.5721 9.86127 38.3252 13.4147 40.9934 18.0021C43.8112 22.847 44.1843 28.6388 43.936 32.6357C43.9141 32.9897 43.7638 33.3235 43.5133 33.5743C43.2629 33.825 42.9297 33.9754 42.5763 33.9972C42.223 34.0191 41.8738 33.9107 41.5946 33.6927C41.3154 33.4746 41.1253 33.1618 41.0602 32.8132L40.9716 32.3259C40.6305 30.4351 40.3024 28.63 38.5109 27.0956C36.6755 25.523 33.0689 24.0732 25.6665 23.8485V31.9998C25.6664 32.3039 25.5832 32.6021 25.4257 32.8622C25.2683 33.1224 25.0427 33.3345 24.7733 33.4756C24.504 33.6167 24.2012 33.6814 23.8977 33.6628C23.5942 33.6441 23.3016 33.5428 23.0515 33.3698Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a7a8ab153b556658b96d3fec3d10b5b1.svg";
export { ForwardRef as ReactComponent };